import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface customerAddressInterface {
    id: number
    customerId: number
    name: string
    addressLine1: string
    addressLine2: string | null
    addressLine3: string | null
    city: string
    stateProvince: string | null
    countryCode: string
    postalCode: string
    phoneNumber: string | null
    isResidential: boolean | null
}

export interface customerInterface {
    id: number
    addresses: customerAddressInterface[]
    createdAt: string
    updatedAt: string
    name: string
    merchantId: number
    channelId: number
    defaultAddressId: number
    email: string
    phoneNumber: string
};

export default (axios: AxiosInstance = baseAxios): { fetchCustomers: () => Promise<customerInterface[]>; } => ({
    fetchCustomers: async (): Promise<customerInterface[]> => {
        const response = await axios.get<customerInterface[]>('/api/orders/customers');
        return response.data;
    },
});
